import createMuiTheme, { Theme } from '@material-ui/core/styles/createMuiTheme';
import { BTCSPrimaryColor } from './constants';
import { paletteDark } from './palette-dark';
import { baseMUITheme } from './theme';
import { typography } from './typography';

// any because of themename..
export const themeDark: Theme = (createMuiTheme as any)({
  themeName: 'Dark Theme',
  // spread base-theme into the lighter version
  ...baseMUITheme,

  // typo
  typography: typography(paletteDark),

  // palette
  palette: paletteDark,

  overrides: {
    ...baseMUITheme.overrides,
    MuiButton: {
      ...(baseMUITheme.overrides as any).MuiButton,
      containedPrimary: {
        '&:hover': {
          backgroundColor: BTCSPrimaryColor,
        },
      },
      containedSecondary: {
        backgroundColor: '#EEEEEE',
        color: '#262626',
        '&:hover': {
          backgroundColor: '#DDDDDD',
        },
      },
    },
  },
});
